/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Section } from '../../components/Section';
import { Paper, TextField, Button } from '@mui/material';
import useErrorHandler from '../../utils/userErrorHandler';
import { useSnackbar } from 'notistack';
import useAcTagQuery from './gql/acTag';
import useAcTagMutation from './gql/updateAcTag';

const TagEditPage: React.FC = () => {
    const params = useParams();
    const id = params.id as string;
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const acTagResp = useAcTagQuery({ id: parseInt(id) });
    const [updateAcTag, updatedAcTagResp] = useAcTagMutation();

    useErrorHandler(acTagResp.error, updatedAcTagResp.error);

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (updatedAcTagResp.data) {
            navigate('/marketing/tags');
        }
    }, [updatedAcTagResp.data]);

    useEffect(() => {
        if (acTagResp.data) {
            setName(acTagResp.data.name);
            setDescription(acTagResp.data.description ? acTagResp.data.description : '');
        }
    }, [acTagResp.data]);

    const handleEdit = () => {
        if (name !== '' && description !== '') {
            updateAcTag({ id: parseInt(id), data: { name, description } });
        } else {
            enqueueSnackbar('A csillaggal jelölt mezők kitöltése kötelező!', { variant: 'error' });
        }
    };

    return (
        <Paper css={containerStyles} elevation={0}>
            <Section title={`#${id}: Tag szerkesztése`}>
                <div css={sectionStyles}>
                    <TextField label="Név" placeholder="A tag neve" variant="outlined" value={name} onChange={(e) => setName(e.target.value)} required />
                    <TextField label="Leírás" placeholder="A tag leírása" variant="outlined" value={description} onChange={(e) => setDescription(e.target.value)} multiline rows={5} required />

                    <div style={{ marginLeft: 'auto' }}>
                        <Button variant="contained" color="success" size="large" onClick={handleEdit} style={{ marginLeft: 'auto' }}>
                            Módosít
                        </Button>
                    </div>
                </div>
            </Section>
        </Paper>
    );
};

const containerStyles = css`
    max-width: 1500px;
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    margin: auto;
    margin-bottom: 25px;
    margin-top: 25px;
    gap: 25px;
`;

const sectionStyles = css`
    display: flex;
    flex-direction: column;
    padding: 20px;

    & > * + * {
        margin-top: 20px !important;
    }
`;

export default TagEditPage;
